import React from 'react';
import Image from '@atlaskit/image';
import ErrorState from './error-state.svg';

export const ErrorStateImage = () => <Image src={ErrorState} alt="" width={171.25} />;
